import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './index.css';
import './select-styles.css';
import './timeline-range.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { AppProvider } from 'lib/context/app';
import * as Sentry from '@sentry/react';

// Initialize React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

// Initialize Sentry
Sentry.init({
  dsn: 'https://5b50421980da175074ac4b22e2bf8491@o109274.ingest.us.sentry.io/4507095424630784',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.httpClientIntegration(),
    Sentry.extraErrorDataIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['error', 'warn'],
    }),
  ],
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.REACT_APP_ENV || 'development',
  enabled: ['sandbox', 'staging', 'production'].includes(
    process.env.REACT_APP_ENV as string
  ),
});

// Create root and render
const container = document.getElementById('root');
if (!container) throw new Error('Root container not found');

const root = createRoot(container);
root.render(
  <QueryClientProvider client={queryClient}>
    <AppProvider>
      <App />
    </AppProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);
